import { ScheduleType } from 'mbs-ui-shared@models/backup/schedule-models';
import { PlanMode, PlanTypes, PlanTypesDisplay } from 'mbs-ui-shared@models/PlanTypes.enum';
import { WizardHelpersSettings } from 'wizards/helpers/bases/base-for-steps-helper';
import { PlanDataFromStepsHelper } from 'wizards/helpers/plan-data-from-steps-helper/plan-data-from-steps-helper';
import { BaseForPlanHelper } from 'wizards/models/base/base-models/base-for-plan-helper';
import { ConsistencyCheckModel } from 'wizards/models/consistency-check/consistency-check-model';

export class ConsistencyCheckPlanFromStepsHelper extends BaseForPlanHelper {
  public static consistencyCheckFormData: ConsistencyCheckModel = null;

  public static getUpdatedPlan(plan, model: ConsistencyCheckModel, settings: WizardHelpersSettings, isUnix = false): any {
    this.consistencyCheckFormData = model;
    this.isNBF = false;
    this.isUnix = isUnix;
    this.updateSchedules(
      +ScheduleType[model.scheduleStep.ScheduleType] === ScheduleType.recurring,
      this.consistencyCheckFormData.scheduleAdvancedStep
    );
    const newPlan = Object.assign({}, plan);
    this.updateModel(newPlan, settings);
    return newPlan;
  }

  private static updateModel(newPlan, settings: WizardHelpersSettings): void {
    if (settings.mode === PlanMode.create) this.updateName(newPlan);

    PlanDataFromStepsHelper.updateNewPlanByWhereBackupStep(newPlan, this.consistencyCheckFormData.whereBackupStep, true);
    PlanDataFromStepsHelper.updateNewPlanByCompressionEncryptionStepConsistency(
      newPlan,
      this.consistencyCheckFormData.compressionEncryptionStep
    );
    PlanDataFromStepsHelper.updateNewPlanByScheduleStepConsistency(
      newPlan,
      this.consistencyCheckFormData.scheduleStep,
      this.consistencyCheckFormData.scheduleAdvancedStep
    );
    PlanDataFromStepsHelper.preparePlanForSending(newPlan, !settings.isRD);

    delete newPlan.Actions;
  }

  private static updateName(newPlan): void {
    const id = this.consistencyCheckFormData.whereBackupStep.ConnectionID;
    let storage = this.consistencyCheckFormData.Storages.CloudStorages.find((s) => s.ID === id);

    if (!storage) {
      storage = this.consistencyCheckFormData.Storages.LocalStorages.find((s) => s.ID === id);
    }

    const name = storage.DisplayName?.split('(')?.[0].trim();
    newPlan.Name = `${PlanTypesDisplay[PlanTypes.ConsistencyCheck]} for ${name}`;
  }
}
